/*
 * Adds scroll shadow divs and an event listener to adjust shadow opacity
 * @param  {array} tableHeight     calculated Table Height
 */
export default function tableScrollShadow(tableHeight) {
  // const bodyContainer = document.querySelector('.ag-body-container');
  const bodyContainer = document.querySelector('.ag-body-container');

  if (!bodyContainer) {
    return;
  }

  const vp = document.querySelector('.ag-body-viewport');
  const fullWidthVp = document.querySelector('.ag-full-width-viewport');
  const marginLeft =
    document.querySelector('.ag-body-viewport-wrapper').style.marginLeft;
  const shadowLeftAdjust = marginLeft.replace('px', '') - 10;
  const shadowTopAdjust = -10;

  // If there is any of the shadow elements present, we've already
  // initialized the shadow elements and scroll event
  if (document.querySelector('.ag-scroll-shadow-right')) {
    document.querySelector('.ag-scroll-shadow-bottom').style.opacity =
      0 >= (bodyContainer.clientHeight - tableHeight) ? 0 : 1;

    document.querySelector('.ag-scroll-shadow-right').style.opacity =
      0 >= (bodyContainer.clientWidth - vp.clientWidth) ? 0 : 1;

    // If we have already added shadow divs, we need to set the left
    // position in case columns were resized
    const shadowLeft = document.querySelector('.ag-scroll-shadow-left');
    shadowLeft.style.left = `${shadowLeftAdjust}px`;

    const shadowRight = document.querySelector('.ag-scroll-shadow-right');
    shadowRight.style.opacity =
      0 >= (bodyContainer.clientWidth - vp.clientWidth) ? 0 : 1;

    return;
  }

  const shadowRight = document.createElement('div');
  const shadowLeft = document.createElement('div');
  const shadowTop = document.createElement('div');
  const shadowBottom = document.createElement('div');

  shadowTop.className = 'ag-scroll-shadow-top';
  shadowTop.style.width = vp.clientWidth;
  shadowTop.style['z-index'] = 9999999;

  shadowBottom.className = 'ag-scroll-shadow-bottom';
  shadowBottom.style.width = vp.clientWidth;
  shadowBottom.style['z-index'] = 9999999;

  shadowRight.className = 'ag-scroll-shadow-right';
  shadowLeft.className = 'ag-scroll-shadow-left';
  fullWidthVp.appendChild(shadowTop);

  fullWidthVp.appendChild(shadowBottom);
  fullWidthVp.appendChild(shadowRight);
  fullWidthVp.appendChild(shadowLeft);

  shadowTop.style.opacity = 0;
  shadowLeft.style.opacity = 0;

  vp.addEventListener('scroll', () => {
    const scrollRight =
      bodyContainer.clientWidth - vp.clientWidth - vp.scrollLeft;
    const scrollBottom =
      bodyContainer.clientHeight - vp.clientHeight - vp.scrollTop;

    shadowRight.style.opacity = 1 < scrollRight / 20 ?
      1.0 : scrollRight / 20;
    shadowLeft.style.opacity = 1 < vp.scrollLeft / 20 ?
      1.0 : vp.scrollLeft / 20;
    shadowTop.style.opacity = 1 < vp.scrollTop / 20 ?
      1.0 : vp.scrollTop / 20;
    shadowBottom.style.opacity = 1 < (scrollBottom / 20) ?
      1.0 : scrollBottom / 20;
  });

  shadowBottom.style.opacity =
    0 >= (bodyContainer.clientHeight - tableHeight) ? 0 : 1;

  shadowRight.style.opacity =
    0 >= (bodyContainer.clientWidth - vp.clientWidth) ? 0 : 1;

  shadowLeft.style.left = `${shadowLeftAdjust}px`;
  shadowTop.style.top = `${shadowTopAdjust}px`;
}



// WEBPACK FOOTER //
// ./app/utils/ui/tableScrollShadow.js